<template>
  <b-container fluid>
    <NavigationBar></NavigationBar>
    <b-container class="container mt-5">
      <b-form
        @submit.prevent="
          handleSubmit(selectedDate, selectedRoomID, selectDurationID)
        "
      >
        <b-form-group class="mb-3" label="預約日期" label-for="bookingDate">
          <b-form-select
            id="bookingDate"
            v-model="selectedDate"
            :options="dateOptions"
            @input="handleDateChange"
            required
          >
          </b-form-select>
        </b-form-group>
        <b-form-group class="mb-3" label="預約房型" label-for="bookingRoom">
          <b-form-select
            class="w-50"
            id="bookingTSTRoom"
            v-model="selectedRoomID"
            :options="roomsTSTOptions"
            @input="handleRoomChange"
          >
          </b-form-select>
          <b-form-select
            class="w-50"
            id="bookingYURoom"
            v-model="selectedRoomID"
            :options="roomsYUOptions"
            @input="handleRoomChange"
          >
          </b-form-select>
        </b-form-group>
        <b-form-group class="mb-3" label="預約時段" label-for="bookingTime">
          <b-form-select
            id="bookingTime"
            v-model="selectDurationID"
            :options="durationsOptions"
            required
          >
          </b-form-select>
        </b-form-group>
        <b-form-group class="text-center">
          <b-button type="submit" variant="primary" :disabled="loading"
            >提交</b-button
          >
        </b-form-group>
        <div>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-alert variant="success" show>
              會議室租用守則:<br />
              ·請準時交還場地以供下節租用者使用，租用時間應包括場地準備及收拾。<br />
              ·逾時10分鐘或以上者會被收取額外房租(以每節計;不足一節亦當一節計算)
              。</b-alert
            >
          </div>
        </div>
      </b-form>
      <ErrorDisplay :error_message="error_Message" />
    </b-container>
  </b-container>
</template>

<script>
import ErrorDisplay from "./ErrorDisplay.vue";
import NavigationBar from "./NavigationBar.vue";
import api from "@/api";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      error_Message: "",
      selectedDate: null,
      selectedRoomID: null,
      selectDurationID: null,
      dateOptions: [],
      roomsTSTOptions: [],
      roomsYUOptions: [],
      durationsOptions: [],
      available_schedules_data: [],
    };
  },
  async created() {
    this.tabId = window.name || "Unknown Tab";
    this.currentFboId =
      localStorage.getItem(`fbo_id_${this.tabId}`) || "Not Found";

    this.dateOptions.push({
      value: null,
      text: "請選擇日期",
      disable: true,
    });

    const currentDate = new Date();
    const currentDay = currentDate.getDate();
    const current_time = new Date().getHours();

    const lastDayCurrentMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() + 1,
      0,
    ).getDate();

    const startDate = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
    );
    let endDate;

    if (currentDay < 20 || (currentDay == 20 && current_time < 10)) {
      endDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        lastDayCurrentMonth,
      );
    } else if (currentDay > 20 || (currentDay == 20 && current_time >= 10)) {
      const nextYear =
        currentDate.getMonth() === 11
          ? currentDate.getFullYear() + 1
          : currentDate.getFullYear();

      const nextMonth =
        currentDate.getMonth() < 11 ? currentDate.getMonth() + 1 : 0;

      const lastDayNextMonth = new Date(nextYear, nextMonth + 1, 0).getDate();

      endDate = new Date(nextYear, nextMonth, lastDayNextMonth);
    }

    while (startDate <= endDate) {
      const dayOfWeek = startDate.getDay();

      const excludeDay = new Date(2026, 9, 1);

      if (dayOfWeek === 0 && startDate >= excludeDay) {
        startDate.setDate(startDate.getDate() + 1);
        continue;
      }

      const dateStr = `${String(startDate.getFullYear())}-${String(
        startDate.getMonth() + 1,
      ).padStart(2, "0")}-${String(startDate.getDate()).padStart(2, "0")}`;

      const days = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const weekDayStr = days[dayOfWeek];
      this.dateOptions.push(`${dateStr} (${weekDayStr})`);
      startDate.setDate(startDate.getDate() + 1);
    }

    this.roomsTSTOptions.push({
      value: null,
      text: "請選擇尖沙咀房型",
      disable: true,
    });
    this.roomsYUOptions.push({
      value: null,
      text: "請選擇元朗房型",
      disable: true,
    });
    this.durationsOptions.push({
      value: null,
      text: "請選擇時段",
      disable: true,
    });
  },
  methods: {
    ...mapActions(["getFBOData"]),
    async handleDateChange() {
      this.selectedRoomID = null;
      this.selectDurationID = null;
      this.roomsOptions = [];
      this.durationsOptions = [];
      this.durationsOptions.push({
        value: null,
        text: "請選擇時段",
        disable: true,
      });
      if (this.selectedDate == null) {
        return;
      }
      try {
        const available_schedules_response = await api.post(
          "/api/available_schedules/",
          {
            selected_date: this.selectedDate.split(" (")[0],
            fbo_id: this.currentFboId,
          },
        );
        if (available_schedules_response.data.status == "error") {
          this.error_Message = available_schedules_response.data.error_message;
          return;
        }
        if (
          available_schedules_response.data.status == "success" &&
          available_schedules_response.data.response_data.length != 0
        ) {
          this.available_schedules_data =
            available_schedules_response.data.response_data;
          console.log(this.selectedDate);

          this.available_schedules_data.forEach((data) => {
            if (data["location"] === "尖沙咀") {
              this.roomsTSTOptions.push({
                value: data["room_id"],
                text: `${data["location"]}: ${data["label"]}房(${data["name"]})`,
                location: data["location"],
                label: data["label"],
              });
            }
            if (data["location"] === "元朗") {
              this.roomsYUOptions.push({
                value: data["room_id"],
                text: `${data["location"]}: ${data["label"]}房(${data["name"]})`,
                location: data["location"],
                label: data["label"],
              });
            }
          });
        } else {
          this.error_Message = "網路連線錯誤。";
        }
        this.roomsTSTOptions = this.roomsTSTOptions.filter(
          (room, index, arr) =>
            index === arr.findIndex((r) => r.value === room.value),
        );
        this.roomsYUOptions = this.roomsYUOptions.filter(
          (room, index, arr) =>
            index === arr.findIndex((r) => r.value === room.value),
        );
        this.roomsTSTOptions.sort((r1, r2) => {
          if (r1.value == null) return -1;
          if (r2.value == null) return 1;
          return r1.label.localeCompare(r2.label);
        });
      } catch (e) {
        this.error_Message = "";
      }
    },
    handleRoomChange() {
      console.log(this.roomsTSTOptions);
      console.log(this.roomsYUOptions);

      this.selectDurationID = null;
      this.durationsOptions = [];
      this.durationsOptions.push({
        value: null,
        text: "請選擇時段",
        disable: true,
      });

      let today = () => {
        let date = new Date();
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
          2,
          "0",
        )}-${String(date.getDate()).padStart(2, "0")}`;
      };
      this.available_schedules_data.forEach((data) => {
        if (this.selectedRoomID == data["room_id"]) {
          const formattedDuration = data["duration"]
            .replace(/:00$/, "")
            .replace(/:00-/, "-");

          if (today() == this.selectedDate.split(" (")[0]) {
            let end_time_str = data["duration"].split("-")[1];
            let time_now = new Date();
            let [hours, minutes] = end_time_str.split(":").map(Number);
            let end_time = new Date(
              time_now.getFullYear(),
              time_now.getMonth(),
              time_now.getDate(),
              hours,
              minutes,
            );
            if (Date.now() < end_time.getTime()) {
              this.durationsOptions.push({
                value: data["duration_id"],
                text: formattedDuration,
              });
            }
          } else {
            this.durationsOptions.push({
              value: data["duration_id"],
              text: formattedDuration,
            });
          }
        }
      });
      this.durationsOptions.sort((a, b) => {
        if (a.value === null) return -1;
        if (b.value === null) return 1;
        const startA = a.text.split("-")[0];
        const startB = b.text.split("-")[0];
        return startA.localeCompare(startB);
      });
    },
    async handleSubmit(selectedDate, selectedRoomID, selectDurationID) {
      this.loading = true;
      try {
        let response = await api.post("/api/booking/", {
          fbo_id: this.currentFboId,
          date: selectedDate,
          duration_id: selectDurationID,
          room_id: selectedRoomID,
        });

        if (response.data.status == "success") {
          this.selectedDate = null;
          this.selectedRoomID = null;
          this.selectDurationID = null;
          this.roomsOptions = [];
          this.durationsOptions = [];
          this.roomsOptions.push({
            value: null,
            text: "請選擇房型",
            disable: true,
          });
          this.durationsOptions.push({
            value: null,
            text: "請選擇時段",
            disable: true,
          });
          alert("已成功預約，確認電郵己發送到你的郵箱。");
          await this.getFBOData(this.currentFboId);
        }
        if (response.data.status == "fail" || response.data.status == "error") {
          this.error_Message = response.data.error_message;
        }
      } catch (e) {
        this.error_Message = "網路連線錯誤。";
      } finally {
        this.loading = false;
      }
    },
  },
  components: {
    NavigationBar,
    ErrorDisplay,
  },
};
</script>
